import { IconWrapper } from '../runtime';
export default IconWrapper('shared', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M10.7707 4.32064L7.03328 6.57072M7.20193 9.61122L10.2158 10.9822M7.5 8.24971C7.5 10.0446 6.04493 11.4997 4.25 11.4997C2.45507 11.4997 1 10.0446 1 8.24971C1 6.45478 2.45507 4.99971 4.25 4.99971C6.04493 4.99971 7.5 6.45478 7.5 8.24971ZM15 3.24971C15 4.49235 13.9926 5.49971 12.75 5.49971C11.5074 5.49971 10.5 4.49235 10.5 3.24971C10.5 2.00707 11.5074 0.99971 12.75 0.99971C13.9926 0.99971 15 2.00707 15 3.24971ZM15 11.9997C15 13.3804 13.8807 14.4997 12.5 14.4997C11.1193 14.4997 10 13.3804 10 11.9997C10 10.619 11.1193 9.49971 12.5 9.49971C13.8807 9.49971 15 10.619 15 11.9997Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});